import "./main.css";
import $dfe96401c0c81db3$exports from "./ar-AE.mjs";
import $f504605657ece833$exports from "./bg-BG.mjs";
import $ed0ab9e7c53f9351$exports from "./cs-CZ.mjs";
import $59d9df99e04ee555$exports from "./da-DK.mjs";
import $c5df0169c370d169$exports from "./de-DE.mjs";
import $3c9af509a01a8d08$exports from "./el-GR.mjs";
import $aa36476f91664a08$exports from "./en-US.mjs";
import $d96f2251ced25e45$exports from "./es-ES.mjs";
import $16ec4ffbd4b2ca4b$exports from "./et-EE.mjs";
import $60f372f660e937e4$exports from "./fi-FI.mjs";
import $d87c5f1e899f6af1$exports from "./fr-FR.mjs";
import $6899669fa63c7816$exports from "./he-IL.mjs";
import $3597d722a30a8081$exports from "./hr-HR.mjs";
import $3ef905a2ce0921cb$exports from "./hu-HU.mjs";
import $e59d2e4af9ff1c28$exports from "./it-IT.mjs";
import $422a7013ab2cb36d$exports from "./ja-JP.mjs";
import $a58a7ab9570c5a18$exports from "./ko-KR.mjs";
import $24e660c5a5be82af$exports from "./lt-LT.mjs";
import $a222e05de6d8dce8$exports from "./lv-LV.mjs";
import $524caea23ab94ad7$exports from "./nb-NO.mjs";
import $572079ed86210ca9$exports from "./nl-NL.mjs";
import $6a0777ee77a74b18$exports from "./pl-PL.mjs";
import $ea0401974d81b469$exports from "./pt-BR.mjs";
import $701d0854e4f18979$exports from "./pt-PT.mjs";
import $dd9fccd10d0a4be3$exports from "./ro-RO.mjs";
import $3cd1eab3b0ecc980$exports from "./ru-RU.mjs";
import $d109f3d68ba24ffc$exports from "./sk-SK.mjs";
import $6382c2117e9fd1b6$exports from "./sl-SI.mjs";
import $ba796dd79114e2d4$exports from "./sr-SP.mjs";
import $916521e9800ac46c$exports from "./sv-SE.mjs";
import $acd72b88f580fe64$exports from "./tr-TR.mjs";
import $bd065904f1420f31$exports from "./uk-UA.mjs";
import $0128cc194bc107bb$exports from "./zh-CN.mjs";
import $c57738f6094a3d25$exports from "./zh-TW.mjs";
import {useStyleProps as $6WzO6$useStyleProps, classNames as $6WzO6$classNames, SlotProvider as $6WzO6$SlotProvider, useDOMRef as $6WzO6$useDOMRef} from "@react-spectrum/utils";
import {Flex as $6WzO6$Flex} from "@react-spectrum/layout";
import {useId as $6WzO6$useId, mergeProps as $6WzO6$mergeProps, filterDOMProps as $6WzO6$filterDOMProps} from "@react-aria/utils";
import $6WzO6$react from "react";
import {useFormProps as $6WzO6$useFormProps} from "@react-spectrum/form";
import $6WzO6$spectrumiconsuiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import $6WzO6$spectrumiconsuiAsterisk from "@spectrum-icons/ui/Asterisk";
import {useLocalizedStringFormatter as $6WzO6$useLocalizedStringFormatter} from "@react-aria/i18n";
import {useProviderProps as $6WzO6$useProviderProps} from "@react-spectrum/provider";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


var $beda4304297005df$exports = {};

$parcel$export($beda4304297005df$exports, "focus-ring", () => $beda4304297005df$export$f39a09f249340e2a, (v) => $beda4304297005df$export$f39a09f249340e2a = v);
$parcel$export($beda4304297005df$exports, "i18nFontFamily", () => $beda4304297005df$export$8c4ee2c50c22c514, (v) => $beda4304297005df$export$8c4ee2c50c22c514 = v);
$parcel$export($beda4304297005df$exports, "is-disabled", () => $beda4304297005df$export$d35bc1e505d1ebbf, (v) => $beda4304297005df$export$d35bc1e505d1ebbf = v);
$parcel$export($beda4304297005df$exports, "spectrum-FocusRing-ring", () => $beda4304297005df$export$4109102f950813a6, (v) => $beda4304297005df$export$4109102f950813a6 = v);
$parcel$export($beda4304297005df$exports, "spectrum-FocusRing", () => $beda4304297005df$export$24c7f46a6e3605dd, (v) => $beda4304297005df$export$24c7f46a6e3605dd = v);
$parcel$export($beda4304297005df$exports, "spectrum-FocusRing--quiet", () => $beda4304297005df$export$2927016961429360, (v) => $beda4304297005df$export$2927016961429360 = v);
$parcel$export($beda4304297005df$exports, "spectrum-HelpText", () => $beda4304297005df$export$c0875e83c57c7736, (v) => $beda4304297005df$export$c0875e83c57c7736 = v);
$parcel$export($beda4304297005df$exports, "spectrum-HelpText--negative", () => $beda4304297005df$export$d31dd875d69daee0, (v) => $beda4304297005df$export$d31dd875d69daee0 = v);
$parcel$export($beda4304297005df$exports, "spectrum-HelpText--neutral", () => $beda4304297005df$export$6e9351b1ad13c, (v) => $beda4304297005df$export$6e9351b1ad13c = v);
$parcel$export($beda4304297005df$exports, "spectrum-HelpText-text", () => $beda4304297005df$export$a512452beb4231bf, (v) => $beda4304297005df$export$a512452beb4231bf = v);
$parcel$export($beda4304297005df$exports, "spectrum-HelpText-validationIcon", () => $beda4304297005df$export$527776642b333691, (v) => $beda4304297005df$export$527776642b333691 = v);
var $beda4304297005df$export$f39a09f249340e2a;
var $beda4304297005df$export$8c4ee2c50c22c514;
var $beda4304297005df$export$d35bc1e505d1ebbf;
var $beda4304297005df$export$4109102f950813a6;
var $beda4304297005df$export$24c7f46a6e3605dd;
var $beda4304297005df$export$2927016961429360;
var $beda4304297005df$export$c0875e83c57c7736;
var $beda4304297005df$export$d31dd875d69daee0;
var $beda4304297005df$export$6e9351b1ad13c;
var $beda4304297005df$export$a512452beb4231bf;
var $beda4304297005df$export$527776642b333691;
$beda4304297005df$export$f39a09f249340e2a = `a1Qy2q_focus-ring`;
$beda4304297005df$export$8c4ee2c50c22c514 = `a1Qy2q_i18nFontFamily`;
$beda4304297005df$export$d35bc1e505d1ebbf = `a1Qy2q_is-disabled`;
$beda4304297005df$export$4109102f950813a6 = `a1Qy2q_spectrum-FocusRing-ring`;
$beda4304297005df$export$24c7f46a6e3605dd = `a1Qy2q_spectrum-FocusRing ${$beda4304297005df$export$4109102f950813a6}`;
$beda4304297005df$export$2927016961429360 = `a1Qy2q_spectrum-FocusRing--quiet`;
$beda4304297005df$export$c0875e83c57c7736 = `a1Qy2q_spectrum-HelpText`;
$beda4304297005df$export$d31dd875d69daee0 = `a1Qy2q_spectrum-HelpText--negative`;
$beda4304297005df$export$6e9351b1ad13c = `a1Qy2q_spectrum-HelpText--neutral`;
$beda4304297005df$export$a512452beb4231bf = `a1Qy2q_spectrum-HelpText-text`;
$beda4304297005df$export$527776642b333691 = `a1Qy2q_spectrum-HelpText-validationIcon`;


function $8e50676506611310$var$HelpText(props, ref) {
    let { description: description, errorMessage: errorMessage, validationState: validationState, isInvalid: isInvalid, isDisabled: isDisabled, showErrorIcon: showErrorIcon, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = props;
    let domRef = (0, $6WzO6$useDOMRef)(ref);
    let isErrorMessage = errorMessage && (isInvalid || validationState === "invalid");
    let { styleProps: styleProps } = (0, $6WzO6$useStyleProps)(props);
    return /*#__PURE__*/ (0, $6WzO6$react).createElement("div", {
        ...styleProps,
        className: (0, $6WzO6$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($beda4304297005df$exports))), "spectrum-HelpText", `spectrum-HelpText--${isErrorMessage ? "negative" : "neutral"}`, {
            "is-disabled": isDisabled
        }, styleProps.className),
        ref: domRef
    }, isErrorMessage ? /*#__PURE__*/ (0, $6WzO6$react).createElement((0, $6WzO6$react).Fragment, null, showErrorIcon && /*#__PURE__*/ (0, $6WzO6$react).createElement((0, $6WzO6$spectrumiconsuiAlertMedium), {
        UNSAFE_className: (0, $6WzO6$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($beda4304297005df$exports))), "spectrum-HelpText-validationIcon")
    }), /*#__PURE__*/ (0, $6WzO6$react).createElement("div", {
        ...errorMessageProps,
        className: (0, $6WzO6$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($beda4304297005df$exports))), "spectrum-HelpText-text")
    }, errorMessage)) : /*#__PURE__*/ (0, $6WzO6$react).createElement("div", {
        ...descriptionProps,
        className: (0, $6WzO6$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($beda4304297005df$exports))), "spectrum-HelpText-text")
    }, description));
}
/**
 * Help text provides either an informative description or an error message that gives more context about what a user needs to input. It's commonly used in forms.
 */ const $8e50676506611310$export$a67c0bc59081311a = /*#__PURE__*/ (0, $6WzO6$react).forwardRef($8e50676506611310$var$HelpText);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


var $42a96ba05489ca64$exports = {};


































$42a96ba05489ca64$exports = {
    "ar-AE": $dfe96401c0c81db3$exports,
    "bg-BG": $f504605657ece833$exports,
    "cs-CZ": $ed0ab9e7c53f9351$exports,
    "da-DK": $59d9df99e04ee555$exports,
    "de-DE": $c5df0169c370d169$exports,
    "el-GR": $3c9af509a01a8d08$exports,
    "en-US": $aa36476f91664a08$exports,
    "es-ES": $d96f2251ced25e45$exports,
    "et-EE": $16ec4ffbd4b2ca4b$exports,
    "fi-FI": $60f372f660e937e4$exports,
    "fr-FR": $d87c5f1e899f6af1$exports,
    "he-IL": $6899669fa63c7816$exports,
    "hr-HR": $3597d722a30a8081$exports,
    "hu-HU": $3ef905a2ce0921cb$exports,
    "it-IT": $e59d2e4af9ff1c28$exports,
    "ja-JP": $422a7013ab2cb36d$exports,
    "ko-KR": $a58a7ab9570c5a18$exports,
    "lt-LT": $24e660c5a5be82af$exports,
    "lv-LV": $a222e05de6d8dce8$exports,
    "nb-NO": $524caea23ab94ad7$exports,
    "nl-NL": $572079ed86210ca9$exports,
    "pl-PL": $6a0777ee77a74b18$exports,
    "pt-BR": $ea0401974d81b469$exports,
    "pt-PT": $701d0854e4f18979$exports,
    "ro-RO": $dd9fccd10d0a4be3$exports,
    "ru-RU": $3cd1eab3b0ecc980$exports,
    "sk-SK": $d109f3d68ba24ffc$exports,
    "sl-SI": $6382c2117e9fd1b6$exports,
    "sr-SP": $ba796dd79114e2d4$exports,
    "sv-SE": $916521e9800ac46c$exports,
    "tr-TR": $acd72b88f580fe64$exports,
    "uk-UA": $bd065904f1420f31$exports,
    "zh-CN": $0128cc194bc107bb$exports,
    "zh-TW": $c57738f6094a3d25$exports
};



var $cd231e464c886c86$exports = {};

$parcel$export($cd231e464c886c86$exports, "contextualHelp", () => $cd231e464c886c86$export$4ba534aba1836d, (v) => $cd231e464c886c86$export$4ba534aba1836d = v);
$parcel$export($cd231e464c886c86$exports, "field", () => $cd231e464c886c86$export$e0f35d825088c098, (v) => $cd231e464c886c86$export$e0f35d825088c098 = v);
$parcel$export($cd231e464c886c86$exports, "focus-ring", () => $cd231e464c886c86$export$f39a09f249340e2a, (v) => $cd231e464c886c86$export$f39a09f249340e2a = v);
$parcel$export($cd231e464c886c86$exports, "helpText", () => $cd231e464c886c86$export$431a3b688422af44, (v) => $cd231e464c886c86$export$431a3b688422af44 = v);
$parcel$export($cd231e464c886c86$exports, "i18nFontFamily", () => $cd231e464c886c86$export$8c4ee2c50c22c514, (v) => $cd231e464c886c86$export$8c4ee2c50c22c514 = v);
$parcel$export($cd231e464c886c86$exports, "is-disabled", () => $cd231e464c886c86$export$d35bc1e505d1ebbf, (v) => $cd231e464c886c86$export$d35bc1e505d1ebbf = v);
$parcel$export($cd231e464c886c86$exports, "label", () => $cd231e464c886c86$export$1237798dc640739a, (v) => $cd231e464c886c86$export$1237798dc640739a = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field", () => $cd231e464c886c86$export$f6d480ae1e56eba0, (v) => $cd231e464c886c86$export$f6d480ae1e56eba0 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--alignEnd", () => $cd231e464c886c86$export$5354c9be7ada5f83, (v) => $cd231e464c886c86$export$5354c9be7ada5f83 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--hasContextualHelp", () => $cd231e464c886c86$export$9ba23707a252cdd4, (v) => $cd231e464c886c86$export$9ba23707a252cdd4 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--positionSide", () => $cd231e464c886c86$export$2963225c91179589, (v) => $cd231e464c886c86$export$2963225c91179589 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--positionTop", () => $cd231e464c886c86$export$a4ea780a9064d7f9, (v) => $cd231e464c886c86$export$a4ea780a9064d7f9 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-contextualHelp", () => $cd231e464c886c86$export$24fb860d16dd2d3f, (v) => $cd231e464c886c86$export$24fb860d16dd2d3f = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-field", () => $cd231e464c886c86$export$3ab8a3dc7f0563d, (v) => $cd231e464c886c86$export$3ab8a3dc7f0563d = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-labelCell", () => $cd231e464c886c86$export$9cde5aecff012641, (v) => $cd231e464c886c86$export$9cde5aecff012641 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-labelWrapper", () => $cd231e464c886c86$export$a872a8c78b26c9e0, (v) => $cd231e464c886c86$export$a872a8c78b26c9e0 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-wrapper", () => $cd231e464c886c86$export$127df0b7290eb8ef, (v) => $cd231e464c886c86$export$127df0b7290eb8ef = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel", () => $cd231e464c886c86$export$493d18e796ae054, (v) => $cd231e464c886c86$export$493d18e796ae054 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel--alignEnd", () => $cd231e464c886c86$export$885efcc08143a987, (v) => $cd231e464c886c86$export$885efcc08143a987 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel--positionSide", () => $cd231e464c886c86$export$9e6f19dc21f22f2e, (v) => $cd231e464c886c86$export$9e6f19dc21f22f2e = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel-requiredIcon", () => $cd231e464c886c86$export$7c47642c7d46f3c9, (v) => $cd231e464c886c86$export$7c47642c7d46f3c9 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FocusRing-ring", () => $cd231e464c886c86$export$4109102f950813a6, (v) => $cd231e464c886c86$export$4109102f950813a6 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FocusRing", () => $cd231e464c886c86$export$24c7f46a6e3605dd, (v) => $cd231e464c886c86$export$24c7f46a6e3605dd = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FocusRing--quiet", () => $cd231e464c886c86$export$2927016961429360, (v) => $cd231e464c886c86$export$2927016961429360 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Form", () => $cd231e464c886c86$export$94d2bcc94afabd89, (v) => $cd231e464c886c86$export$94d2bcc94afabd89 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Form--positionSide", () => $cd231e464c886c86$export$7f44db659563c8f4, (v) => $cd231e464c886c86$export$7f44db659563c8f4 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Form--positionTop", () => $cd231e464c886c86$export$11b8bc81fe551057, (v) => $cd231e464c886c86$export$11b8bc81fe551057 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Form-itemLabel", () => $cd231e464c886c86$export$51ec27881a1e3928, (v) => $cd231e464c886c86$export$51ec27881a1e3928 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-LabeledValue", () => $cd231e464c886c86$export$79f9a5e9dd010c8d, (v) => $cd231e464c886c86$export$79f9a5e9dd010c8d = v);
var $cd231e464c886c86$export$4ba534aba1836d;
var $cd231e464c886c86$export$e0f35d825088c098;
var $cd231e464c886c86$export$f39a09f249340e2a;
var $cd231e464c886c86$export$431a3b688422af44;
var $cd231e464c886c86$export$8c4ee2c50c22c514;
var $cd231e464c886c86$export$d35bc1e505d1ebbf;
var $cd231e464c886c86$export$1237798dc640739a;
var $cd231e464c886c86$export$f6d480ae1e56eba0;
var $cd231e464c886c86$export$5354c9be7ada5f83;
var $cd231e464c886c86$export$9ba23707a252cdd4;
var $cd231e464c886c86$export$2963225c91179589;
var $cd231e464c886c86$export$a4ea780a9064d7f9;
var $cd231e464c886c86$export$24fb860d16dd2d3f;
var $cd231e464c886c86$export$3ab8a3dc7f0563d;
var $cd231e464c886c86$export$9cde5aecff012641;
var $cd231e464c886c86$export$a872a8c78b26c9e0;
var $cd231e464c886c86$export$127df0b7290eb8ef;
var $cd231e464c886c86$export$493d18e796ae054;
var $cd231e464c886c86$export$885efcc08143a987;
var $cd231e464c886c86$export$9e6f19dc21f22f2e;
var $cd231e464c886c86$export$7c47642c7d46f3c9;
var $cd231e464c886c86$export$4109102f950813a6;
var $cd231e464c886c86$export$24c7f46a6e3605dd;
var $cd231e464c886c86$export$2927016961429360;
var $cd231e464c886c86$export$94d2bcc94afabd89;
var $cd231e464c886c86$export$7f44db659563c8f4;
var $cd231e464c886c86$export$11b8bc81fe551057;
var $cd231e464c886c86$export$51ec27881a1e3928;
var $cd231e464c886c86$export$79f9a5e9dd010c8d;
$cd231e464c886c86$export$4ba534aba1836d = `A-HlBa_contextualHelp`;
$cd231e464c886c86$export$e0f35d825088c098 = `A-HlBa_field`;
$cd231e464c886c86$export$f39a09f249340e2a = `A-HlBa_focus-ring`;
$cd231e464c886c86$export$431a3b688422af44 = `A-HlBa_helpText`;
$cd231e464c886c86$export$8c4ee2c50c22c514 = `A-HlBa_i18nFontFamily`;
$cd231e464c886c86$export$d35bc1e505d1ebbf = `A-HlBa_is-disabled`;
$cd231e464c886c86$export$1237798dc640739a = `A-HlBa_label`;
$cd231e464c886c86$export$f6d480ae1e56eba0 = `A-HlBa_spectrum-Field`;
$cd231e464c886c86$export$5354c9be7ada5f83 = `A-HlBa_spectrum-Field--alignEnd`;
$cd231e464c886c86$export$9ba23707a252cdd4 = `A-HlBa_spectrum-Field--hasContextualHelp`;
$cd231e464c886c86$export$2963225c91179589 = `A-HlBa_spectrum-Field--positionSide`;
$cd231e464c886c86$export$a4ea780a9064d7f9 = `A-HlBa_spectrum-Field--positionTop`;
$cd231e464c886c86$export$24fb860d16dd2d3f = `A-HlBa_spectrum-Field-contextualHelp`;
$cd231e464c886c86$export$3ab8a3dc7f0563d = `A-HlBa_spectrum-Field-field`;
$cd231e464c886c86$export$9cde5aecff012641 = `A-HlBa_spectrum-Field-labelCell`;
$cd231e464c886c86$export$a872a8c78b26c9e0 = `A-HlBa_spectrum-Field-labelWrapper`;
$cd231e464c886c86$export$127df0b7290eb8ef = `A-HlBa_spectrum-Field-wrapper`;
$cd231e464c886c86$export$493d18e796ae054 = `A-HlBa_spectrum-FieldLabel`;
$cd231e464c886c86$export$885efcc08143a987 = `A-HlBa_spectrum-FieldLabel--alignEnd`;
$cd231e464c886c86$export$9e6f19dc21f22f2e = `A-HlBa_spectrum-FieldLabel--positionSide`;
$cd231e464c886c86$export$7c47642c7d46f3c9 = `A-HlBa_spectrum-FieldLabel-requiredIcon`;
$cd231e464c886c86$export$4109102f950813a6 = `A-HlBa_spectrum-FocusRing-ring`;
$cd231e464c886c86$export$24c7f46a6e3605dd = `A-HlBa_spectrum-FocusRing ${$cd231e464c886c86$export$4109102f950813a6}`;
$cd231e464c886c86$export$2927016961429360 = `A-HlBa_spectrum-FocusRing--quiet`;
$cd231e464c886c86$export$94d2bcc94afabd89 = `A-HlBa_spectrum-Form`;
$cd231e464c886c86$export$7f44db659563c8f4 = `A-HlBa_spectrum-Form--positionSide`;
$cd231e464c886c86$export$11b8bc81fe551057 = `A-HlBa_spectrum-Form--positionTop`;
$cd231e464c886c86$export$51ec27881a1e3928 = `A-HlBa_spectrum-Form-itemLabel`;
$cd231e464c886c86$export$79f9a5e9dd010c8d = `A-HlBa_spectrum-LabeledValue`;




function $00af9ba397a66f43$var$Label(props, ref) {
    props = (0, $6WzO6$useProviderProps)(props);
    let { children: children, labelPosition: labelPosition = "top", labelAlign: labelAlign = labelPosition === "side" ? "start" : null, isRequired: isRequired, necessityIndicator: necessityIndicator = isRequired != null ? "icon" : null, includeNecessityIndicatorInAccessibilityName: includeNecessityIndicatorInAccessibilityName = false, htmlFor: htmlFor, for: labelFor, elementType: ElementType = "label", onClick: onClick, ...otherProps } = props;
    let domRef = (0, $6WzO6$useDOMRef)(ref);
    let { styleProps: styleProps } = (0, $6WzO6$useStyleProps)(otherProps);
    let stringFormatter = (0, $6WzO6$useLocalizedStringFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($42a96ba05489ca64$exports))), "@react-spectrum/label");
    let necessityLabel = isRequired ? stringFormatter.format("(required)") : stringFormatter.format("(optional)");
    let icon = /*#__PURE__*/ (0, $6WzO6$react).createElement((0, $6WzO6$spectrumiconsuiAsterisk), {
        UNSAFE_className: (0, $6WzO6$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports))), "spectrum-FieldLabel-requiredIcon"),
        "aria-label": includeNecessityIndicatorInAccessibilityName ? stringFormatter.format("(required)") : undefined
    });
    let labelClassNames = (0, $6WzO6$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports))), "spectrum-FieldLabel", {
        "spectrum-FieldLabel--positionSide": labelPosition === "side",
        "spectrum-FieldLabel--alignEnd": labelAlign === "end"
    }, styleProps.className);
    return /*#__PURE__*/ (0, $6WzO6$react).createElement(ElementType, {
        ...(0, $6WzO6$filterDOMProps)(otherProps),
        ...styleProps,
        onClick: onClick,
        ref: domRef,
        className: labelClassNames,
        htmlFor: ElementType === "label" ? labelFor || htmlFor : undefined
    }, children, (necessityIndicator === "label" || necessityIndicator === "icon" && isRequired) && " \u200B", necessityIndicator === "label" && /*#__PURE__*/ (0, $6WzO6$react).createElement("span", {
        "aria-hidden": !includeNecessityIndicatorInAccessibilityName ? isRequired : undefined
    }, necessityLabel), necessityIndicator === "icon" && isRequired && icon);
}
let $00af9ba397a66f43$export$b04be29aa201d4f5 = /*#__PURE__*/ (0, $6WzO6$react).forwardRef($00af9ba397a66f43$var$Label);






function $b7ca5b4454a2009d$var$Field(props, ref) {
    let formProps = (0, $6WzO6$useFormProps)(props);
    let isInForm = formProps !== props;
    props = formProps;
    let { label: label, labelPosition: labelPosition = "top", labelAlign: labelAlign, isRequired: isRequired, necessityIndicator: necessityIndicator, includeNecessityIndicatorInAccessibilityName: includeNecessityIndicatorInAccessibilityName, validationState: validationState, isInvalid: isInvalid, description: description, errorMessage: errorMessage = (e)=>e.validationErrors.join(" "), validationErrors: validationErrors, validationDetails: validationDetails, isDisabled: isDisabled, showErrorIcon: showErrorIcon, contextualHelp: contextualHelp, children: children, labelProps: labelProps = {}, descriptionProps: // Not every component that uses <Field> supports help text.
    descriptionProps = {}, errorMessageProps: errorMessageProps = {}, elementType: elementType, wrapperClassName: wrapperClassName, wrapperProps: wrapperProps = {}, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $6WzO6$useStyleProps)(otherProps);
    let errorMessageString = null;
    if (typeof errorMessage === "function") errorMessageString = isInvalid != null && validationErrors != null && validationDetails != null ? errorMessage({
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    }) : null;
    else errorMessageString = errorMessage;
    let hasHelpText = !!description || errorMessageString && (isInvalid || validationState === "invalid");
    let contextualHelpId = (0, $6WzO6$useId)();
    let fallbackLabelPropsId = (0, $6WzO6$useId)();
    if (label && contextualHelp && !labelProps.id) labelProps.id = fallbackLabelPropsId;
    let labelWrapperClass = (0, $6WzO6$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports))), "spectrum-Field", {
        "spectrum-Field--positionTop": labelPosition === "top",
        "spectrum-Field--positionSide": labelPosition === "side",
        "spectrum-Field--alignEnd": labelAlign === "end",
        "spectrum-Field--hasContextualHelp": !!props.contextualHelp
    }, styleProps.className, wrapperClassName);
    children = /*#__PURE__*/ (0, $6WzO6$react).cloneElement(children, (0, $6WzO6$mergeProps)(children.props, {
        className: (0, $6WzO6$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports))), "spectrum-Field-field")
    }));
    let renderHelpText = ()=>/*#__PURE__*/ (0, $6WzO6$react).createElement((0, $8e50676506611310$export$a67c0bc59081311a), {
            descriptionProps: descriptionProps,
            errorMessageProps: errorMessageProps,
            description: description,
            errorMessage: errorMessageString,
            validationState: validationState,
            isInvalid: isInvalid,
            isDisabled: isDisabled,
            showErrorIcon: showErrorIcon,
            gridArea: (0, (/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports))).helpText
        });
    let renderChildren = ()=>{
        if (labelPosition === "side") return /*#__PURE__*/ (0, $6WzO6$react).createElement((0, $6WzO6$Flex), {
            direction: "column",
            UNSAFE_className: (0, $6WzO6$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports))), "spectrum-Field-wrapper")
        }, children, hasHelpText && renderHelpText());
        return /*#__PURE__*/ (0, $6WzO6$react).createElement((0, $6WzO6$react).Fragment, null, children, hasHelpText && renderHelpText());
    };
    let labelAndContextualHelp = /*#__PURE__*/ (0, $6WzO6$react).createElement((0, $6WzO6$react).Fragment, null, label && /*#__PURE__*/ (0, $6WzO6$react).createElement((0, $00af9ba397a66f43$export$b04be29aa201d4f5), {
        ...labelProps,
        labelPosition: labelPosition,
        labelAlign: labelAlign,
        isRequired: isRequired,
        necessityIndicator: necessityIndicator,
        includeNecessityIndicatorInAccessibilityName: includeNecessityIndicatorInAccessibilityName,
        elementType: elementType
    }, label), label && contextualHelp && /*#__PURE__*/ (0, $6WzO6$react).createElement((0, $6WzO6$SlotProvider), {
        slots: {
            actionButton: {
                UNSAFE_className: (0, $6WzO6$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports))), "spectrum-Field-contextualHelp"),
                id: contextualHelpId,
                "aria-labelledby": (labelProps === null || labelProps === void 0 ? void 0 : labelProps.id) ? `${labelProps.id} ${contextualHelpId}` : undefined
            }
        }
    }, contextualHelp));
    // Need to add an extra wrapper for the label and contextual help if labelPosition is side,
    // so that the table layout works inside forms.
    if (isInForm && labelPosition === "side" && label && contextualHelp) labelAndContextualHelp = /*#__PURE__*/ (0, $6WzO6$react).createElement("div", {
        className: (0, $6WzO6$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports))), "spectrum-Field-labelCell")
    }, /*#__PURE__*/ (0, $6WzO6$react).createElement("div", {
        className: (0, $6WzO6$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports))), "spectrum-Field-labelWrapper")
    }, labelAndContextualHelp));
    return /*#__PURE__*/ (0, $6WzO6$react).createElement("div", {
        ...styleProps,
        ...wrapperProps,
        ref: ref,
        className: labelWrapperClass
    }, labelAndContextualHelp, renderChildren());
}
let $b7ca5b4454a2009d$export$a455218a85c89869 = /*#__PURE__*/ (0, $6WzO6$react).forwardRef($b7ca5b4454a2009d$var$Field);






export {$b7ca5b4454a2009d$export$a455218a85c89869 as Field, $00af9ba397a66f43$export$b04be29aa201d4f5 as Label, $8e50676506611310$export$a67c0bc59081311a as HelpText};
//# sourceMappingURL=module.js.map
